(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGORender"), require("FEGOWebapi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGORender", "FEGOWebapi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/fund-card-hori/render"] = factory(require("VueDemi"), require("FEGORender"), require("FEGOWebapi"));
	else
		root["/fego/component/fund-card-hori/render"] = factory(root["VueDemi"], root["FEGORender"], root["FEGOWebapi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__, __WEBPACK_EXTERNAL_MODULE__5322__, __WEBPACK_EXTERNAL_MODULE__5113__) => {
return 